import "../App.css";
import "./Maintenance.css";

import logoECJ from "../img/ecj-logo.svg";

function App() {

  return (
    <div className='bgMaintenance '>
      <div className='contentMaintenance'>
        <div>
          <img
            className='logoECJMaintenance'
            src={logoECJ}
            alt="EconoJournal"
          />
        </div>
        <h1>Estamos trabajando en las inscripciones de la próxima edición.</h1>
        <h2>Pronto vas a poder registrarte aquí.</h2>
      </div>
    </div>
  );
}

export default App;